import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Store a phone as E.164. A national trunk prefix typed after the country
 * code, such as New Zealand `+6402…`, is repaired when the result is a real
 * number. Anything that is still not a valid number is dropped.
 */
export function normalizeE164Phone(
  value: string | null | undefined,
): string | null {
  if (value == null) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const direct = parsePhoneNumberFromString(trimmed);
  if (direct?.isValid()) return direct.number;

  // Only retry with a single leading plus when the value already tried to be
  // international. Prefixing a bare national number would invent a country.
  if (!trimmed.includes("+")) return null;
  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return null;
  const international = parsePhoneNumberFromString(`+${digits}`);
  if (international?.isValid()) return international.number;
  return null;
}
